import React, { Suspense, lazy } from "react";
import { Analytics } from "@vercel/analytics/react";
import ReactDOM from "react-dom/client";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";

//Styles
import "./global.css";

//Components
import Header from "./Components/Header";
import Loading from "./Components/Loading";

//Pages
const HomePage = lazy(() => import("./Home/HomePage"));
const Settings = lazy(() => import("./Settings/SettingsPage"));
const NotFoundPage = lazy(() => import("./404"));
const AboutPage = lazy(()=> import("./About/AboutPage"))

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
	<React.StrictMode>
		<Analytics />
		<div className="container">
			<Header />
			<div className="contentWrap">
				<Router>
					<Routes>
						<Route
							index
							element={
								<Suspense fallback={<Loading />}>
									<HomePage />
								</Suspense>
							}
						/>
						<Route
							path="settings"
							element={
								<Suspense fallback={<Loading />}>
									<Settings />
								</Suspense>
							}
						/>

						<Route 
						path="about"
						element={
							<Suspense fallback={<Loading />}>
								<AboutPage />
							</Suspense>
						}
						/>

						<Route
							path="*"
							element={
								<Suspense fallback={<Loading />}>
									<NotFoundPage />
								</Suspense>
							}
						/>
					</Routes>
				</Router>
			</div>
			{/*^ .contentWrap ^*/}
		</div>
		{/* .^ container ^ */}
		
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();
